import React from 'react';
import PropTypes from 'prop-types';
import imgUserDefault from '../../../../../../assets/img/default-user.png';
import { InfoMenu } from './info-menu/InfoMenu';
import './UserInfo.css';

export const UserInfo = (
    {
        currentUser,
    },
) => {
    const srcImage = currentUser.hasImage() ? currentUser.image() : imgUserDefault;
    const backgroundColor = () => {
        if ( currentUser.isSuperAdmin() ) return '#FFC72C';
        if ( currentUser.isAdmin() ) return '#4AD084';
        if ( currentUser.isOutsourcesManager() ) return '#E47977';
        if ( currentUser.isOutsourcesViewer() ) return '#02B4CE';
        if ( currentUser.isContractorsManager() ) return '#607D8B';
        return '#222222';
    };

    return (
        <div className="ps-user-info" style={{ backgroundColor: backgroundColor() }}>
            <img src={srcImage} width="48" height="48" alt="User"/>
            <span className="ps-name">{currentUser.completeName()}</span>
            <span>{currentUser.email()}</span>
            <span>{currentUser.roleName()}</span>
            <div className="ps-company">
                <span>{currentUser.myCompanyName()}</span>
                <InfoMenu/>
            </div>
        </div>
    );
};

UserInfo.propTypes = {
    currentUser: PropTypes.object.isRequired,
};

UserInfo.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/sidebar/user-info/UserInfo.jsx